import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=f2d735b8&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"
import style0 from "./Pay.vue?vue&type=style&index=0&id=f2d735b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d735b8",
  null
  
)

export default component.exports